module.exports = __webpack_public_path__ + "static/img/download-logo.b0bb14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-logo.jpg
// module id = i+2p
// module chunks = 1